

export const Select = ({ id, items, onChange, selectedValue }) => {

    const handleChange = (e) => {
        onChange(items[e.target.value]);
    };

    return (
        <>
            <div className="d-inline-block me-3 fw-bold">
                Ordenar Por
            </div>
            <select id={id} class="form-select d-inline-block w-auto r" aria-label="Default select example" onChange={handleChange}>
                {items.map(function (elem, i) {
                    return (
                        <option value={i} selected={selectedValue ? selectedValue.text === elem.text : i == 0}>{elem.text}</option>
                    )
                })}
            </select>
        </>
    )
}